/* ============================================================
   BackToTop — The Practice Engine (Light Theme)
   Fixed bottom-LEFT button (away from the chat avatar bottom-right
   and the mobile gold "Claim Now" bar). Appears after scrolling
   down ~400px, fades/scales in, smooth-scrolls to top on click.
   ============================================================ */
import { ArrowUp } from "lucide-react";
import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollUp = () => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: 0, left: 0, behavior: reduce ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      onClick={scrollUp}
      aria-label="Back to top"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      className="fixed left-4 sm:left-6 bottom-20 sm:bottom-6 z-50 w-11 h-11 rounded-full flex items-center justify-center shadow-lg transition-all duration-200 ease-out active:scale-95"
      style={{
        background: "#0B1220",
        color: "#FFFFFF",
        opacity: visible ? 1 : 0,
        transform: visible ? "scale(1) translateY(0)" : "scale(0.95) translateY(8px)",
        pointerEvents: visible ? "auto" : "none",
        border: "1px solid rgba(0,194,212,0.5)",
      }}
    >
      <ArrowUp size={20} strokeWidth={2.5} style={{ color: "#00C2D4" }} />
    </button>
  );
}
